import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const GraphicsContainer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  will-change: transform;

  &::before {
    content: "";
    position: absolute;
    left: -32px;
    top: -32px;
    width: 60px;
    height: 60px;
    background: repeating-linear-gradient(
      90deg,
      #ffce3c,
      #ffce3c 4px,
      transparent 4px,
      transparent 8px
    );
    opacity: 0.7;
    border-radius: 8px;
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    right: -32px;
    top: 16px;
    width: 80px;
    height: 80px;
    border: 3px solid #ffce3c;
    border-radius: 50%;
    opacity: 0.7;
    z-index: 0;
  }
`;
const BarGraph = styled.svg `
  position: absolute;
  right: 400px;
  top: 30px;
  width: 240px;
  height: 140px;
  z-index: 2;
  opacity: 0.18 !important;

  @media (max-width: 900px) {
    width: 120px !important;
    height: 60px !important;
    left: 0 !important;
    right: unset !important;
    top: unset !important;
    bottom: unset !important;
  }
`;
const PieChart = styled.svg `
  position: absolute;
  right: 80px;
  top: 80px;
  width: 120px;
  height: 120px;
  z-index: 2;
  opacity: 1 !important;

  @media (max-width: 900px) {
    width: 120px !important;
    height: 60px !important;
    left: 0 !important;
    right: unset !important;
    top: unset !important;
    bottom: unset !important;
  }
`;
const LineChart = styled.svg `
  position: absolute;
  left: 2vw;
  bottom: 10px;
  width: 200px;
  height: 80px;
  z-index: 2;
  opacity: 0.18 !important;

  @media (max-width: 900px) {
    width: 120px !important;
    height: 60px !important;
    left: 0 !important;
    right: unset !important;
    top: unset !important;
    bottom: unset !important;
  }
`;
export const HeroGraphics = () => {
    return (_jsxs(GraphicsContainer, { children: [_jsx(BarGraph, { className: "hero-bar-graph parallax hero-fade", width: "240", height: "140", viewBox: "0 0 120 70", fill: "none", children: _jsxs("g", { children: [_jsx("rect", { x: "10", y: "40", width: "12", height: "20", fill: "#ffce3c" }), _jsx("rect", { x: "30", y: "30", width: "12", height: "30", fill: "#ffce3c" }), _jsx("rect", { x: "50", y: "20", width: "12", height: "40", fill: "#ffce3c" }), _jsx("rect", { x: "70", y: "10", width: "12", height: "50", fill: "#ffce3c" }), _jsx("polyline", { points: "16,40 36,30 56,20 76,10", fill: "none", stroke: "#111", strokeWidth: "2" }), _jsx("circle", { cx: "76", cy: "10", r: "3", fill: "#111" })] }) }), _jsxs(PieChart, { className: "hero-pie parallax hero-opaque", width: "120", height: "120", viewBox: "0 0 32 32", children: [_jsx("circle", { r: "16", cx: "16", cy: "16", fill: "#ffce3c" }), _jsx("path", { d: "M16 16 L16 0 A16 16 0 0 1 32 16 Z", fill: "#111" })] }), _jsx(LineChart, { className: "hero-line parallax hero-fade", width: "200", height: "80", viewBox: "0 0 60 20", children: _jsx("polyline", { points: "0,20 10,10 20,15 30,5 40,10 50,0 60,8", fill: "none", stroke: "#ffce3c", strokeWidth: "3" }) })] }));
};
